<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>

            <el-col :span="12" class="item">
              <el-form-item label="绑定老人" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="请选择绑定老人" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="设备类型" required prop="deviceType">
                <el-select v-model="addForm.deviceType" placeholder="请选择设备类型" style="width: 100%">
                  <el-option
                      v-for="item in type_arr"
                      :key="item.val"
                      :label="item.name"
                      :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="设备号" required prop="imei">
                <el-input v-model="addForm.imei" placeholder="请输入设备号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import GetElderly from "@/views/Elderly/Comm/ElderlyGovClass";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,
      showModalGetElderly: false,

      addForm:{
        timeStr:timeStr,
        sign:'',

        phone:'',
        userName:'',
        governmentCode:'',

        userCode:'',
        imei:'',
        deviceType:'',

      },

      type_arr:[
        //{val:1, name:'清雷'},
        {val:2, name:'驰通达'},
        {val:3, name:'欧万'},
        {val:4, name:'睡倍健'},
      ],

      rules:{
        imei:[
          { required: true, message: '请输入设备号', trigger: 'blur' },
        ],
        deviceType:[
          { required: true, message: '选择设备类型', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ]
      }


    }
  },
  components: {GetElderly},
  methods: {
    init(){
      this.$refs.addForm.resetFields();
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    setElderly(row){
      this.addForm.userCode=row.userCode;
      this.addForm.phone = row.phone;
      this.addForm.userName = row.name;
      this.addForm.idCard = row.idCard;
      this.addForm.governmentCode = row.governmentCode;
    },


    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLSign/GovAdd2",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },


  }
}

</script>


<style lang="scss" scoped>

</style>
